/*
 * @Description: 内部结算单价修改
 * @Author: 杨志航
 * @Date: 2026-03-23 16:12:15
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  InputNumber,
  message,
  DatePicker,
  Upload,
  Icon,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { uploadDragger } from '@/utils/uploadDragger'
import { allTrim, filterParams } from '@/utils'

const FormItem = Form.Item
const { Dragger } = Upload
const dateFormat = 'YYYY-MM-DD HH:mm'
let draggerObj = {}

const EditSettle = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const { setEditVisible, getList, editData } = props
  const [saveLoading, setSaveLoading] = useState(false)

  useEffect(() => {
    draggerObj = uploadDragger({
      accept: '.jpg, .jpeg, .png, .pdf',
      limitNum: 20,
      limitSize: 20,
    })
    const { attachment, desc } = editData
    if (attachment) {
      setFieldsValue({
        attachment: JSON.parse(attachment).map(item => {
          const { filename, url } = item
          return {
            uid: '-1',
            name: filename,
            status: 'done',
            url,
          }
        }),
      })
    }
    if (desc) {
      setFieldsValue({
        desc,
      })
    }
  }, [])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        const { companyId, supplierCompanyId, projectId, productId, supplierId } = editData
        vals = filterParams(vals)
        vals.effectiveTime = vals.effectiveTime.format(dateFormat) + ':00'
        vals.attachment = vals.attachment.map(item => {
          const { name, url } = item
          return {
            filename: name,
            url,
          }
        })
        vals = {
          ...vals,
          companyId,
          supplierCompanyId,
          projectId,
          productId,
          supplierId,
        }
        setSaveLoading(true)
        api.getInternalSettlementPercent(vals).then(() => {
          setSaveLoading(false)
          setEditVisible(false)
          message.success('编辑成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="转出公司">
          {editData.companyName || '--'}
        </FormItem>
        <FormItem label="转入公司">
          {editData.supplierCompanyName || '--'}
        </FormItem>
        <FormItem label="供应商">
          {editData.supplierName || '--'}
        </FormItem>
        <FormItem label="项目">
          {editData.projectName || '--'}
        </FormItem>
        <FormItem label="产品">
          {editData.productName || '--'}
        </FormItem>
        <FormItem label="当前结算单价">
          {editData.percent || '--'}
        </FormItem>
        <FormItem label="新结算单价">
          {getFieldDecorator('percent', {
            rules: [{ required: true, message: '请输入新结算单价' }]
          })(
            <InputNumber 
              placeholder="请输入新结算单价" 
              style={{ width: '100%'}}
              min={0.0001}
              max={1.0000}
              step={0.0001}
              precision={4}
            />
          )}
        </FormItem>
        <FormItem label="当前生效时间">
          {editData.effectiveTime ? editData.effectiveTime.slice(0, -3) : '--'}
        </FormItem>
        <FormItem label="新生效时间">
          {getFieldDecorator('effectiveTime', {
            rules: [{ required: true, message: '请选择新生效时间' }]
          })(
            <DatePicker 
              placeholder="请选择" 
              showTime
              format={dateFormat}
              style={{ width: '100%'}}
            />
          )}
        </FormItem>
        <Form.Item label="备注信息">
          {getFieldDecorator('desc')(
            <Input.TextArea placeholder="请输入备注信息" rows={6} maxLength={500}/>
          )}
        </Form.Item>
        <Form.Item label="上传附件">
          {getFieldDecorator('attachment', {
            valuePropName: 'fileList',
            getValueFromEvent: draggerObj.normFile,
            rules: [{ required: true, message: '请上传附件' }]
          })(
            <Dragger {...draggerObj}>
              <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
              </p>
              <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
              <p className="ant-upload-hint">
                支持扩展名：.jpg、.jpeg、.png、.pdf<br/>单个文件大小不超过20M，不超过20个附件。
              </p>
            </Dragger>
          )}
        </Form.Item>
        <BtnGroup onCancel={() => setEditVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(EditSettle)
